import React, { useState } from 'react'
import { Rate, Input, Button } from 'antd'
import './LeaveReview.css'
import google from './google.png'
import facebook from './facebook.png'
import axios from 'axios'
import ModalComponent from '../../UI/ModalComponent'
import ReviewModal from '../ReviewModal'
import { useDispatch } from 'react-redux'
import { modalOptions, showModal } from '../../../redux/slices/ModalSlice'
import { useSelector } from 'react-redux'

interface LeaveReviewProps {
    setReviews: ([]) => void  
}

const LeaveReview = ({setReviews}:LeaveReviewProps) => {
const [rating, setRating] = useState <number>(0) 
const [message, setMessage] = useState <string>('')
const [name, setName] = useState <string>('')
const dispatch = useDispatch()
let modal = useSelector(modalOptions)

const createReview = () => {
    axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/createReview`, {
        rating,
        message,
        name
    })
    .then(res => {
        console.log('Review Created:', { ...res.data })
        setReviews([ ...res.data ])
        dispatch(showModal('review'))
        setRating(0)
        setMessage('')
        setName('')
    })
    .catch(err => {
        console.log('error on create review', err)
    })
}

return (
    <div className="leave-review-container">
    <div className="r-container">
        <h1 className="text-color-white review-title">Leave us a review</h1>
        <div className="review-link-container">
            
        <a href="https://www.facebook.com/TangledLeadWelding" target="_blank">
            <img className="review-link" src={facebook} />
        </a>
        {process.env.REACT_APP_ENV === "development" ? 
        <a>
            <img className="review-link" src={google} />
        </a>
        : null }
        </div>
        <span>Your feedback helps us and our potential customers!</span>
        <Rate
        value={rating}
        onChange={value => setRating(value)}
        className="rate"
        defaultValue={5}
        />
        <div className="r-container" style={{ alignItems: 'flex-start' }}>
        <span className="fw-500 text-color-white">Name:</span>
        <Input
            onChange={e => setName(e.target.value)}
            value={name}
            className="review-input"
            type="text"
            placeholder="Name..."
        />
        </div>
        <div className="r-container" style={{ alignItems: 'flex-start' }}>
        <span className="fw-500 text-color-white">
            Let us know how we did...
        </span>
        <Input.TextArea
            value={message}
            onChange={e => setMessage(e.target.value)}
            className="review-text"
            placeholder="Leave feedback..."
        />
        </div>
        <ModalComponent modalName={'review'}>
            <ReviewModal />
        </ModalComponent>
        <Button onClick={createReview} className="leave-review-btn">
        Submit
        </Button>
    </div>
    </div>
)
}

export default LeaveReview



